export const eLimitedTextName = {
    email: 'email',
    sms: 'sms',
};

export const eFormMode = {
    create: 'create',
    update: 'update',
};
